import React, { FC } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import { makeStyles } from 'tss-react/mui'
import { Shared } from 'ui/shared'
import { useBonusMinutesFilter } from './BonusMinutesFilter-ViewModel'
import { Grid } from '@mui/material'

export const DAY_WIDTH = 50

const BonusMinutesFilter: FC = () => {
  const { classes } = useStyles()
  const { t, onCancel, form, isFilterOn, onClearFilter } = useBonusMinutesFilter()
  const { handleSubmit, register, formValidation } = form

  return (
    <Shared.Card style={{ width: 375 }}>
      <Shared.CardTitle title={t('bonusMinutes')} />
      <form autoComplete="off" onSubmit={handleSubmit}>
        <Grid item xs={12}>
          <Shared.Divider />
        </Grid>
        <Grid item xs={12}>
          <Shared.InputField
            name="bonusMinutes"
            title={'Minutes'}
            register={register(formValidation.bonusMinutes)}
            type="tel"
            inputProps={{
              maxLength: 9,
            }}
          />
        </Grid>
        <Grid item xs={6} className={classes.buttons}>
          <Shared.Button className={classes.button} title={'No'} onClick={onCancel} color={'secondary'} />
          <Shared.Button className={classes.button} width={'100%'} title={'Submit'} type="submit" color={'primary'} />
        </Grid>
        {isFilterOn && (
          <Shared.Button
            className={classes.button}
            width={'100%'}
            title={'Clear filter'}
            type="submit"
            color={'primary'}
            onClick={onClearFilter}
          />
        )}
      </form>
    </Shared.Card>
  )
}

export default BonusMinutesFilter

const useStyles = makeStyles()((theme) => ({
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 16,
  },
  button: {
    margin: 4,
  },
}))
